import BaseUIStoreSettingStickertView from 'xui/modules/print/BaseUIStoreSettingStickertView'

export default class StoreSettingStickerView extends BaseUIStoreSettingStickertView {
  static displayName = 'StoreSettingStickerView'

  static navigationOptions = {
    header: null,
  }
}
